// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-section {
  width: 80%;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 24px;
}

.right-section-mobile{
  width: 100%;
}
.right-section-hidden-mobile{
  display: none;
}

.header-section {
  flex: 0.2 1;
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

.arrow-wrapper{
  display: flex;
  align-items: center;
  gap: 10px;
}

.arrow-btn{
  background: transparent;
  border: none;
  cursor: pointer;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
}

.input-container {
  display: flex;
  gap: 16px;
  position: relative;
}

.patient-name {
  font-size: 16px;
  font-weight: 500;
  color: #111827;
}

.patient-input {
  width: 40%;
  padding: 8px 16px;
  padding-left: 40px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
}

.input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  color: #9ca3af;
}

.submit-button {
  padding: 8px 16px;
  background-color: #0d9488;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  margin-left: 10px;
}

.submit-button:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}


/* PatientDropdown.css */
.patient-dropdown-container {
  position: relative;
  width: 200px;
  font-family: Arial, sans-serif;

}

.dropdown-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px 15px;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
}

.dropdown-button:hover {
  border-color: #9ca3af;
}

.dropdown-icon {
  border: solid #666;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transition: transform 0.2s ease;
}

.dropdown-icon-open {
  transform: rotate(-135deg);
}

.dropdown-icon-closed {
  transform: rotate(45deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
}

.dropdown-menu-hidden {
  display: none;
}

.dropdown-menu-visible {
  display: block;
}

.dropdown-option {
  padding: 10px 15px;
  cursor: pointer;
  font-size: 14px;
}

.dropdown-option:hover {
  background-color: #f3f4f6;
}

.tabs-navigation {
  display: flex;
  margin-bottom: 1rem;
  gap: 1rem;
}

.tab-button {
  padding: 0.75rem 1.25rem;
  font-weight: 500;
  font-size: 0.875rem;
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.tab-button:hover {
  color: #0d9488;
  font-weight: 600;
}

.tab-button.active {
  color: #0d9488;
  font-weight: 600;
}

.tab-button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #0d9488;
  font-weight: 600;
}

.active-component {
  border: 2px dashed #e5e7eb;
  border-radius: 8px;
  flex: 0.8 1;
}




@media (max-width: 1024px) {
  .right-section {
    width: 75%;
    padding: 16px;
    padding-top: 5%;
  }
}

@media (max-width:600px){
  .header-section {
    flex: 0.2 1;
    margin: 20px 0px;
  }
  
  .patient-name {
    padding-top: 20px;
  }
  .patient-input {
    width: 60%;
  }
  .active-component {
    margin-bottom: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboardComponent/DashboardRightSection.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAS;EACT,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;;AAGA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;;AAEhC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,WAAS;AACX;;;;;AAKA;EACE;IACE,UAAU;IACV,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".right-section {\n  width: 80%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n}\n\n.right-section-mobile{\n  width: 100%;\n}\n.right-section-hidden-mobile{\n  display: none;\n}\n\n.header-section {\n  flex: 0.2;\n  margin-bottom: 32px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n}\n\n.arrow-wrapper{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.arrow-btn{\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.page-title {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n\n.input-container {\n  display: flex;\n  gap: 16px;\n  position: relative;\n}\n\n.patient-name {\n  font-size: 16px;\n  font-weight: 500;\n  color: #111827;\n}\n\n.patient-input {\n  width: 40%;\n  padding: 8px 16px;\n  padding-left: 40px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.input-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  color: #9ca3af;\n}\n\n.submit-button {\n  padding: 8px 16px;\n  background-color: #0d9488;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  margin-left: 10px;\n}\n\n.submit-button:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n\n/* PatientDropdown.css */\n.patient-dropdown-container {\n  position: relative;\n  width: 200px;\n  font-family: Arial, sans-serif;\n\n}\n\n.dropdown-button {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 10px 15px;\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n}\n\n.dropdown-button:hover {\n  border-color: #9ca3af;\n}\n\n.dropdown-icon {\n  border: solid #666;\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 3px;\n  transition: transform 0.2s ease;\n}\n\n.dropdown-icon-open {\n  transform: rotate(-135deg);\n}\n\n.dropdown-icon-closed {\n  transform: rotate(45deg);\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n}\n\n.dropdown-menu-hidden {\n  display: none;\n}\n\n.dropdown-menu-visible {\n  display: block;\n}\n\n.dropdown-option {\n  padding: 10px 15px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.dropdown-option:hover {\n  background-color: #f3f4f6;\n}\n\n.tabs-navigation {\n  display: flex;\n  margin-bottom: 1rem;\n  gap: 1rem;\n}\n\n.tab-button {\n  padding: 0.75rem 1.25rem;\n  font-weight: 500;\n  font-size: 0.875rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.tab-button:hover {\n  color: #0d9488;\n  font-weight: 600;\n}\n\n.tab-button.active {\n  color: #0d9488;\n  font-weight: 600;\n}\n\n.tab-button.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #0d9488;\n  font-weight: 600;\n}\n\n.active-component {\n  border: 2px dashed #e5e7eb;\n  border-radius: 8px;\n  flex: 0.8;\n}\n\n\n\n\n@media (max-width: 1024px) {\n  .right-section {\n    width: 75%;\n    padding: 16px;\n    padding-top: 5%;\n  }\n}\n\n@media (max-width:600px){\n  .header-section {\n    flex: 0.2;\n    margin: 20px 0px;\n  }\n  \n  .patient-name {\n    padding-top: 20px;\n  }\n  .patient-input {\n    width: 60%;\n  }\n  .active-component {\n    margin-bottom: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
